import {html} from 'lit';

export const facet8Template = () => html`
    <div class="image-shapes-8--crop-mobile">
        <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 360 270" xml:space="preserve">
            <path class="fill-violet500" d="M2,80.1l153.3,88L2.4,257.4L2,80.1 M0,76.7l0.4,184.2l158.9-92.7L0,76.7L0,76.7z"/>
            <path class="fill-lightblue400" d="M360,218.8l0-53.1l-96.8,55.9l0,0l46,26.5C331.8,261.2,360,244.9,360,218.8z"/>
        </svg>
    </div>

    <div class="image-shapes-8">
        <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 380 301" xml:space="preserve">
            <polygon class="fill-darkblue400" points="311.1,109.2 361.7,138.4 361.6,196.6 311.1,167.5 "/>
            <polygon class="fill-violet500" points="361.6,196.5 311.1,167.5 311.1,225.7 "/>
        </svg>
    </div>
    <div class="image-shapes-8-bottom">
        <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 380 301" xml:space="preserve">
            <path class="fill-lightblue400" d="M311.2,264l0-38.4l-69.9,40.4l0,0l33.2,19.2C290.8,294.7,311.2,282.9,311.2,264z"/>
        </svg>
    </div>
`;